import { createContext, useContext } from 'react';
import type { UserAgentData } from '../../lib/getUserAgent';

export const UserAgentContext = createContext<UserAgentData>({
    isMobile: false,
    isTablet: false,
    isTouch: false,
});
export const useUserAgentContext = () => useContext(UserAgentContext);
